import { css } from "styled-components";

export const BotPreviewCardStyles = {
  card: css`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
  `,
  logoNameWrapper: css<{ $isMobile?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: ${(p) => (p.$isMobile ? "12px" : "20px")};
  `,
  symbol: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;
  `,
  cardActions: css`
    position: absolute;
    right: 0;
    top: -4px;
  `,
  createdWrapper: css`
    display: flex;
    flex-direction: row;
  `,
  sectionWrapper: css<{ $isMobile?: boolean }>`
    display: flex;
    flex-direction: column;
    padding: ${(p) => (p.$isMobile ? "12px 0 12px 0" : "16px 0 16px 0")};
  `,
  propertyRow: css<{ $isMobile?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    ${(props) =>
      props.$isMobile &&
      `
    overflow: hidden;
    display: block;
    padding: 6px 0;
    `}
  `,
};

export const ActiveTradePreviewStyles = {
  noTradeText: css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 4px;
  `,
  statisticsWrapper: css<{
    $useActiveTradeRows?: boolean;
  }>`
    display: flex;
    flex-direction: row;
    ${(p) =>
      p.$useActiveTradeRows &&
      `
      flex-direction: column;
    `}
  `,
  statisticWrapper: css<{
    $useActiveTradeRows?: boolean;
  }>`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    ${(p) =>
      p.$useActiveTradeRows &&
      `
      flex-direction: row;
      justify-content: space-between;
      padding: 4px 0;
      border: none !important;
    `}
  `,
};

export const PublicBotCardStyles = {
  logoNameWrapper: css<{ $isMobile?: boolean }>`
    display: flex;
    flex-direction: row;
    padding-bottom: 8px;
  `,
};
